import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/subscription/[frequency]/components/PlanTabItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/ui/tabs.tsx");
